import "core-js/modules/es6.regexp.split";
import PropTypes from 'prop-types';
import keys from 'lodash/keys';
import transform from 'lodash/transform';
import omit from 'lodash/omit';
import last from 'lodash/last';
import dropRight from 'lodash/dropRight';
import isEmpty from 'lodash/isEmpty';
import createReduxContextStore from './context-store-redux';
export default function createContextStore(preloadData) {
  // create the base store, needs to be observable
  var store = createReduxContextStore({
    preloadData: preloadData
  }); // holds counts of instances and subscriptions

  var counts = {};

  var register = function register() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var key = path.join('.');
    var count = counts[key] || 0;
    counts[key] = count + 1;
  };

  var unregister = function unregister() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var key = path.join('.');
    var count = counts[key] || 0;
    if (count === 0) throw new Error("Cannot unregister: No context registerd to key: ".concat(key)); // eslint-disable-line prettier/prettier

    if (count > 1) {
      counts[key] = count - 1;
      return;
    } // remove this and cleanup;


    delete counts[key]; // remove any non-subscribed context instances

    var toKeep = transform(counts, function (memo, ct, keypath) {
      if (keypath.indexOf(key)) return;
      memo.push(keypath.split('.').slice(path.length, 1));
    }, []); // remove this key entirely if nothing is listening

    if (path.length && isEmpty(toKeep)) return store.remove(last(path), dropRight(path)); // eslint-disable-line prettier/prettier
    // remove all data in this context, except other subscribed contexts

    return store.remove(keys(omit(store.get(key, path), toKeep)), path);
  };

  var _subscribe = function subscribe() {
    var onChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    register(path);
    var unsubscribe = store.subscribe(function () {
      var data = store.get(undefined, path);
      return onChange(data);
    });
    return function () {
      unsubscribe();
      unregister(path);
    };
  };

  return {
    path: [],
    get: function get(key) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return store.get(key, path);
    },
    set: function set(key, value) {
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return store.set(key, value, path);
    },
    remove: function remove(keys) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return store.remove(keys, path);
    },
    // eslint-disable-line no-shadow
    subscribe: function subscribe(onChange) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return _subscribe(onChange, path);
    },

    // for tests
    get counts() {
      return counts;
    },

    // for debugging
    get data() {
      return store.get(undefined, []);
    }

  };
}
export var propType = PropTypes.shape({
  get: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  subscribe: PropTypes.func.isRequired
});